import { Link } from "react-router-dom";
import ergoniqLogo from "@/assets/ergoniq-logo.webp";

export function BrandLogo({ className = "", testId }) {
  return (
    <Link to="/dashboard" className={`inline-flex items-center gap-2 ${className}`} data-testid={testId}>
      <img src={ergoniqLogo} alt="Ergoniq" className="h-6 w-auto" />
      <span className="font-heading text-xs font-bold uppercase tracking-widest text-[var(--oim-text-muted)]">OIM</span>
    </Link>
  );
}
